import React from "react";
import { FaPhoneAlt, FaArrowRight, FaCheckCircle, FaStar } from "react-icons/fa";
import {
  BannerContent,
  Container,
  UpperContainer,
  HeroButtonGroup,
  HeroTrustStrip,
} from "./Banner.styles";
import Navbar from "../LandingNav";

const Banner = () => {
  return (
    <Container className="banner-container">
      <UpperContainer className="upper-banner-container">
        <Navbar />
        <BannerContent>
          <div className="hero-pill-badge">
            <FaStar className="badge-icon" /> Official C-Store & Lottery Display System
          </div>
          <h1>
            Free Your Counter Space,{" "}
            <span className="highlight-text">Maximize Lottery Sales</span>
          </h1>
          <p className="hero-description">
            Upgrade your store with 4K digital scratcher boards, live jackpot prize
            feeds, and complete one-stop C-Store solutions — from text overlay CCTV
            to commercial canopy LED lighting.
          </p>

          <HeroButtonGroup>
            <a href="#services" className="hero-btn-primary">
              Explore All 10 Services <FaArrowRight />
            </a>
            <a href="tel:6823860871" className="hero-btn-secondary">
              <FaPhoneAlt /> Call (682) 386-0871
            </a>
          </HeroButtonGroup>

          <HeroTrustStrip>
            <div className="trust-pill">
              <FaCheckCircle className="check-icon" />
              <span>1,000+ Stores</span>
            </div>
            <div className="trust-pill">
              <FaCheckCircle className="check-icon" />
              <span>+35% Sales Boost</span>
            </div>
            <div className="trust-pill">
              <FaCheckCircle className="check-icon" />
              <span>25+ Yrs Experience</span>
            </div>
          </HeroTrustStrip>
        </BannerContent>
      </UpperContainer>
    </Container>
  );
};

export default Banner;
